import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ChallengesService {
  constructor(private http: HttpClient) {}

  getAllChallenges(langCode: any, searchTerm: string = ''): Observable<any> {
    return this.http.get(
      `${environment.authUrl}/challenges/admin/getChallanges`,
      {
        headers: { lang: langCode },
        params: { searchTerm }
      }
    );
  }

  createChallenge(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/challenges`, data);
  }

  deleteChallengeTranslation(id: any): Observable<any> {
    return this.http.delete(
      `${environment.authUrl}/challenges/deletechallenge/${id}`
    );
  }

  deleteChallenge(id: any): Observable<any> {
    return this.http.delete(
      `${environment.authUrl}/challenges/${id}`
    );
  }
  getChallengeById(id: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/challenges/${id}`);
  }

  updateChallenge(id: any, data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/challenges/${id}`, data);
  }
}
